import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=0ec62da4&scoped=true"
import script from "./dataForm.vue?vue&type=script&lang=js"
export * from "./dataForm.vue?vue&type=script&lang=js"
import style0 from "./dataForm.vue?vue&type=style&index=0&id=0ec62da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec62da4",
  null
  
)

export default component.exports